<div class="row">
  <div class="col-12">
    <h5 class="my-3 text-mad text-uppercase d-flex justify-content-between">
      <span>nature and extent of valuer's work</span>

      <button mat-raised-button type="button" class="btn btn-primary" color="primary" (click)="onAddScope()">
        Add Scope
      </button>
    </h5>
    <hr class="active" />
  </div>
</div>

<form [formGroup]="form">
  <div class="row">
    <div class="col-4">
      <mat-form-field class="mat-form-field-fluid">
        <mat-select formControlName="report_type_id">
          <mat-option *ngFor="let option of reportTypes" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</form>

<ng-container *ngIf="!(isLoading$|async); else loading">
  <ng-container *ngFor="let scope of (workScopes$|async)"> 
    <div class="row mb-4">
      <div class="col-12 d-flex align-items-center">
        <h6 class="p-0 m-0">{{scope.name}}</h6>

        <button mat-icon-button type="button" (click)="onAddOption(scope.id)" color="primary">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </div>
    <mat-radio-group class="row mb-4" 
      [value]="scope.selectedOptionId"
      (change)="onScopeOfWorkOptionChange(scope.id, $event)">
      <ng-container *ngFor="let option of scope.options">
        <div class="col-3 d-flex align-items-center">
          <mat-radio-button [value]="option.id">
            {{ option.name }}
          </mat-radio-button>
          <button mat-icon-button color="primary" type="button" (click)="onEditOption(scope.id, option)">
            <mat-icon>edit</mat-icon>
          </button>
          <ng-container *ngIf="option.name !== option.defaultName || option.description !== option.defaultDescription">
            <button mat-icon-button color="primary" type="button" (click)="onResetOption(scope.id, option)">
              <mat-icon>refresh</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="!option.isSystem" type="button">
            <button mat-icon-button color="warn" (click)="onDeleteOption(scope.id, option)">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
        </div>
      </ng-container>
    </mat-radio-group>
  </ng-container>
</ng-container>
<ng-template #loading>
  Loading scopes...
</ng-template>